// Request vetting for a contractor who is not on the register — RON-5466 Phase 4.
//
// NOT A BOOKING, and the screen says so twice. Vetting is a separate approval that has to complete
// before the contractor can be invited, so this sends a request to facilities and returns the host
// to the list. Letting it create a visit as well would put an unvetted contractor on a site.

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { EMAIL_PATTERN } from "../../../utils/CommonUtils.js";
import VisitorFormRow, { fieldClassName } from "./VisitorFormRow.jsx";

const ContractorRequestVetting = ({
  initialEmail = "",
  isSubmitting,
  onSubmit,
  onBack,
}) => {
  const { t } = useTranslation("common");

  // Carried over from the lookup so the host does not retype the address they just searched.
  const [form, setForm] = useState({
    email: initialEmail,
    name: "",
    company: "",
    trade: "",
    reason: "",
  });
  const [errors, setErrors] = useState({});

  const setField = (key, value) => {
    setForm((current) => ({ ...current, [key]: value }));
    setErrors({});
  };

  const submit = () => {
    const found = {};

    if (!form.email.trim()) {
      found.email = "react_visitors_error_email_required";
    } else if (!EMAIL_PATTERN.test(form.email.trim())) {
      // Same pattern the rest of the app validates against.
      found.email = "react_visitors_error_email_invalid";
    }
    if (!form.name.trim()) found.name = "react_visitors_error_name";
    if (!form.company.trim()) found.company = "react_visitors_error_company";

    if (Object.keys(found).length) {
      setErrors(found);
      return;
    }

    onSubmit({
      email: form.email.trim(),
      name: form.name.trim(),
      company: form.company.trim(),
      trade: form.trade.trim(),
      reason: form.reason.trim(),
    });
  };

  const field = (key, labelKey, { required = false, type = "text" } = {}) => {
    const label = `${t(labelKey)}${required ? "*" : ""}`;

    return (
      <VisitorFormRow
        id={`vetting-${key}`}
        label={label}
        error={errors[key] ? t(errors[key]) : null}
      >
        <input
          id={`vetting-${key}`}
          type={type}
          placeholder={label}
          className={fieldClassName(form[key], errors[key])}
          value={form[key]}
          onChange={(event) => setField(key, event.target.value)}
        />
      </VisitorFormRow>
    );
  };

  return (
    <div className="visitor-vetting-request">
      <div className="visitor-card">
        <p className="visitor-card__title">{t("react_visitors_request_vetting")}</p>
        <p className="visitor-card__hint">{t("react_visitors_request_vetting_hint")}</p>

        {field("email", "email_address", { required: true, type: "email" })}
        {field("name", "name", { required: true })}
        {field("company", "company", { required: true })}
        {field("trade", "react_visitors_field_trade")}

        {/* Free text, because facilities decide on the case rather than on a category. */}
        <VisitorFormRow id="vetting-reason" label={t("react_visitors_field_reason")}>
          <textarea
            id="vetting-reason"
            rows={3}
            placeholder={t("react_visitors_field_reason")}
            className={fieldClassName(form.reason, null, false)}
            value={form.reason}
            onChange={(event) => setField("reason", event.target.value)}
          />
        </VisitorFormRow>
      </div>

      <div className="visitor-wizard__actions">
        <button
          type="button"
          className="visitor-btn visitor-btn--secondary"
          onClick={onBack}
          disabled={isSubmitting}
        >
          {t("react_visitors_back")}
        </button>
        <button
          type="button"
          className="visitor-btn visitor-btn--secondary"
          onClick={submit}
          disabled={isSubmitting}
        >
          {t("react_visitors_send_request")}
        </button>
      </div>
    </div>
  );
};

export default ContractorRequestVetting;
